import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import ReactTable from 'react-table';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
  Button,
  ButtonToolbar,
} from 'react-bootstrap';
import moment from 'moment';


import {
  reclaimPerDiemModalPropTypes,
  ReclaimPerDiemModal,
  withReclaimPerDiemModalState,
} from './modals/ReclaimPerDiemModal';

import { reclaimPerDiem, setPerDiemId } from '../actions';
import { queryGetPerDiemsMissingTimeEntriesGQL } from '../graphql/getPerDiemsMissingTimeEntriesApi';
import { getUserTimesheetLink } from '../../timesheetNavigator/links';
import { renderTicketNumber, getTicketState } from '../../tickets/utils';

import {
  defaultTableFiltering,
  openInNewTab,
  dateTableSorting,
} from '../../../utils';

const propTypes = exact({
  reclaimPerDiemAction: PropTypes.func.isRequired,
  allPerDiemsMissingTimeEntries: PropTypes.array.isRequired,
  setPerDiemIdAction: PropTypes.func.isRequired,

  ...reclaimPerDiemModalPropTypes,
});

const PerDiemsPaidNotWorked = (props) => {
  const {
    openReclaimModal, closeReclaimModal, showReclaimModal,
  } = props;

  const {
    reclaimPerDiemAction, allPerDiemsMissingTimeEntries,
  } = props;

  const {
    setPerDiemIdAction,
  } = props;

  return (
    <React.Fragment>
      <ReactTable
        data={allPerDiemsMissingTimeEntries}
        filterable
        columns={[
          {
            Header: 'Requested For',
            id: 'requested_for',
            accessor: (e) => { return e.per_diem_date.display; },
            sortMethod: (a, b) => {
              return dateTableSorting(a, b);
            },
            filterMethod: (filter, row) => {
              const customFilterObj = {
                id: filter.id,
                value: filter.value,
              };
              return defaultTableFiltering(customFilterObj, row);
            },
          },
          {
            Header: 'Requested By',
            id: 'requested_by',
            accessor: (e) => { return e.requested_by.fullname; },
            filterMethod: (filter, row) => {
              const customFilterObj = {
                id: filter.id,
                value: filter.value,
              };
              return defaultTableFiltering(customFilterObj, row);
            },
          },
          {
            Header: 'For Employee',
            id: 'for_employee',
            accessor: (e) => { return e.user.fullname; },
            filterMethod: (filter, row) => {
              const customFilterObj = {
                id: filter.id,
                value: filter.value,
              };
              return defaultTableFiltering(customFilterObj, row);
            },
          },
          {
            Header: 'Ticket Number',
            id: 'ticket_number',
            accessor: (e) => { return e.per_diem_request.ticket_number.number; },
            filterMethod: (filter, row) => {
              const customFilterObj = {
                id: filter.id,
                value: filter.value,
              };
              return defaultTableFiltering(customFilterObj, row);
            },
            Cell: (row) => {
              const ticketNumber = row.original.per_diem_request.ticket_number;
              return (
                <div style={{ padding: '7px 5px', color: '#000' }} className={`summary-details-${getTicketState(ticketNumber)}`}>
                  {renderTicketNumber(ticketNumber)}
                </div>
              );
            },
          },
          {
            Header: 'Actions',
            id: 'actions',
            filterable: false,
            sortable: false,
            Cell: (row) => {
              const { user, per_diem_date: perDiemDate, status } = row.original;

              const reversePayment = (!status) ? false : status.reversible;
              /* NOTE: centering the buttons in the actions column by using float none
              * and overriding buttonToolbar. ButtonToolbar adds the spaces between the buttons. */
              return (
                <ButtonToolbar>
                  {reversePayment && (
                    <Button
                      style={{ float: 'none' }}
                      bsStyle="danger"
                      bsSize="small"
                      onClick={() => {
                        setPerDiemIdAction(row.original.id);
                        return openReclaimModal();
                      }}
                    >
                      Reclaim
                    </Button>
                  )}
                  <Button
                    style={{ float: 'none' }}
                    bsStyle="info"
                    bsSize="small"
                    onClick={() => {
                      return (
                        openInNewTab(getUserTimesheetLink(user.id, moment(perDiemDate.iso8601)))
                      );
                    }}
                  >
                    View Timesheet
                  </Button>
                </ButtonToolbar>
              );
            },
          },
        ]}
      />
      <ReclaimPerDiemModal
        show={showReclaimModal}
        onHide={closeReclaimModal}
        reclaimPerDiemAction={reclaimPerDiemAction}
      />
    </React.Fragment>

  );
};

PerDiemsPaidNotWorked.propTypes = propTypes;

const mapDispatchToProps = {
  reclaimPerDiemAction: reclaimPerDiem,
  setPerDiemIdAction: setPerDiemId,
};

const withRedux = connect(null, mapDispatchToProps);

const enhance = compose(
  withRedux,
  queryGetPerDiemsMissingTimeEntriesGQL,
  withReclaimPerDiemModalState,
);


export default enhance(PerDiemsPaidNotWorked);
